import React, { useState } from 'react';
import { bool, object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Popover, Button, Icon } from '@fiverr-private/fit';
import { l_chevron_up as UpIcon, l_chevron_down as DownIcon } from '@fiverr-private/icons';
import { reportContactSellerOptionsClick } from '../../../utils/contactSeller';
import { COPY_ROOT } from './constants';
import PopoverContent from './PopoverContent';

import './style.scss';

const ContactSellerOptions = (props, { biEvents, businessLayout }) => {
    const [isOpen, setIsOpen] = useState(false);

    const onOpen = () => {
        setIsOpen(true);
        reportContactSellerOptionsClick(biEvents);
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const titleSuffix = businessLayout ? 'business_title' : 'title';
    const titleCopy = `${COPY_ROOT}.${titleSuffix}`;

    return (
        <div className="contact-seller-options-wrapper">
            <Popover className="contact-seller-popover"
                contentClassName="contact-seller-popover-content"
                boxContentClassName="popover-box-content"
                appendToBody={false}
                onOpen={onOpen}
                onClose={onClose}
                content={<PopoverContent/>}>
                <Button className="contact-seller-options-btn"
                    color={Button.COLORS.GREY}
                    fill={Button.FILLS.GHOST}>
                    <I18n k={titleCopy}/>
                    <Icon className="button-icon">{isOpen ? UpIcon : DownIcon}</Icon>
                </Button>
            </Popover>
        </div>
    );
};

ContactSellerOptions.contextTypes = {
    biEvents: object,
    businessLayout: bool
};

export default ContactSellerOptions;
